import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useKeys } from 'rooks';
import { platform } from '../../helpers/platform';
import { Button } from '../Button/Button';
export const KeyboardButton = ({ keyboardShortcut: keyboardShortcutPassed, isLoading, isDisabled, ...buttonProps }) => {
    const buttonRef = useRef(null);
    const keyboardShortcut = Array.isArray(keyboardShortcutPassed)
        ? keyboardShortcutPassed
        : keyboardShortcutPassed[platform];
    useKeys(keyboardShortcut, () => {
        if (isLoading || isDisabled)
            return;
        buttonRef.current?.click();
    });
    return (_jsx(Button, { ref: buttonRef, ...buttonProps, isLoading: isLoading, isDisabled: isDisabled }));
};
